<main class="main">
  <d-header></d-header>
  <div class="content">
    <div class="content__col"><router-outlet></router-outlet></div>
  </div>
  <d-footer></d-footer>
</main>
